import { FC } from "react";

const TermsOfUse: FC = () => {
  return (
    <>
      <div className="d-flex flex-column gap-15">
        <div className="fs-22 fw-400 text-black">Terms of Service</div>
        <>
          <p>
            <strong className="text-teal">DEFINED TERMS</strong>
          </p>
          <ol type="1">
            <li>
              <p>
                The following words are given the following meaning in these
                Terms of Business:
              </p>
            </li>
          </ol>
          <table className="table table-bordered">
            {/* <thead>
              <tr className="header">
                <th className="min-w-200px"></th>
                <th></th>
              </tr>
            </thead> */}
            <tbody>
              <tr className="header">
                <td style={{ textWrap: "nowrap", width: "auto" }}>
                  <strong className="text-teal">Candidate</strong>
                </td>
                <td>
                  means anyone introduced to the Client as part of the Services.
                </td>
              </tr>
              <tr className="odd">
                <td>
                  <strong className="text-teal">
                    Confidential Information
                  </strong>
                </td>
                <td>
                  means any information, in any form, relating in any way to
                  either party or their respective businesses, including these
                  Terms and any information relating to a Candidate.
                </td>
              </tr>
              <tr className="even">
                <td>
                  <strong className="text-teal">Consulting Services</strong>
                </td>
                <td>
                  means any consulting services specified in the Schedule.
                </td>
              </tr>
              <tr className="odd">
                <td>
                  <strong className="text-teal">Exclusive Engagement</strong>
                </td>
                <td>has the meaning described in clause 14.</td>
              </tr>
              <tr className="even">
                <td>
                  <strong className="text-teal">
                    Exclusive Engagement Fees
                  </strong>
                </td>
                <td>
                  means the fees specified as being Exclusive Engagement Fees in
                  the Schedule.
                </td>
              </tr>
              <tr className="odd">
                <td>
                  <strong className="text-teal">Guarantee Period</strong>
                </td>
                <td>
                  means the period of time specified in the Schedule starting on
                  the date that a Candidate is employed by the Client.
                </td>
              </tr>
              <tr className="even">
                <td>
                  <strong className="text-teal">
                    Commencement Fee &amp; Placement Fee
                  </strong>
                </td>
                <td>has the meaning in clause 18(a).</td>
              </tr>
              <tr className="odd">
                <td>
                  <strong className="text-teal">Original Candidate</strong>
                </td>
                <td>
                  means, in the context of a Replacement Guarantee, a Candidate
                  employed by the Client who then ceases that employment.
                </td>
              </tr>
              <tr className="even">
                <td>
                  <strong className="text-teal">Position</strong>
                </td>
                <td>
                  means the role that the Client has engaged Lloyd Connect to
                  provide Candidates for, as described in the Schedule, or as
                  otherwise notified to Lloyd Connect by the Client from time to
                  time.
                </td>
              </tr>
              <tr className="odd">
                <td>
                  <strong className="text-teal">TaaS</strong>
                </td>
                <td>
                  means Talent as a Service, and means the provision of services
                  and benefits by Lloyd Connect to the Client, as specified in
                  the Schedule.
                </td>
              </tr>
              <tr className="even">
                <td>
                  <strong className="text-teal">Remuneration</strong>
                </td>
                <td>
                  means the proposed annual gross remuneration to be paid by the
                  Client to the Candidate for the Position, including
                  superannuation and any allowances, benefits, sign-on or
                  guaranteed bonuses, share or equity allocations and
                  commissions.
                </td>
              </tr>
              <tr className="odd">
                <td>
                  <strong className="text-teal">Replacement Guarantee</strong>
                </td>
                <td>has the meaning described in clause 6.</td>
              </tr>
              <tr className="even">
                <td>
                  <strong className="text-teal">Services</strong>
                </td>
                <td>
                  means the introduction of Candidates to the Client who are
                  suitable to be employed on a permanent basis in the Position,
                  and/or any Consulting Services specified in the Schedule.
                </td>
              </tr>
              <tr className="odd">
                <td>
                  <strong className="text-teal">Special Conditions</strong>
                </td>
                <td>
                  means any additional conditions to these Terms as set out in
                  the Schedule.
                </td>
              </tr>
              <tr className="even">
                <td>
                  <strong className="text-teal">
                    Staggered Payment/Retained Services
                  </strong>
                </td>
                <td>has the meaning in clause 18(b).</td>
              </tr>
              <tr className="odd">
                <td>
                  <strong className="text-teal">Standard Placement Fees</strong>
                </td>
                <td>
                  means the fees specified as being Standard Placement Fees in
                  the Schedule.
                </td>
              </tr>
              <tr className="even">
                <td>
                  <strong className="text-teal">Subscription Fee</strong>
                </td>
                <td>
                  is the annual fee to be paid by the Client to Lloyd Connect
                  for the Services to be provided as a TaaS package.
                </td>
              </tr>
              <tr className="odd">
                <td>
                  <strong className="text-teal">Terms</strong>
                </td>
                <td>means these Terms of Business.</td>
              </tr>
            </tbody>
          </table>
          <p>
            <strong>TERMS OF BUSINESS</strong>
          </p>
          <ol start={2} type="1">
            <li>
              <p>
                These Terms specify the terms and conditions on which Lloyd
                Connect will provide the Services to the Client and will have
                effect from the date set out in the Schedule, or if no date is
                provided, the date the Client accepts the provision of any
                Services from Lloyd Connect. The Terms will remain in force
                between the parties until all obligations between the parties
                have been satisfied, unless terminated earlier in accordance
                with these Terms.
              </p>
            </li>
            <li>
              <p>
                As an existing client of Llyod Connect, Lloyd Connect agrees to
                provide you with access to our service offering ‘Connected Crew’
                and its platform. Your use of this service and platform will be
                governed by the Terms of Access and Privacy Policy applicable to
                ‘Connected Crew’ and its platform.
              </p>
            </li>
            <li>
              <p>
                Access to Connected Crew will initially be free of charge,
                however, we may begin charging for the provision of this service
                by notice to you, at our sole discretion and in accordance with
                the Terms of Access applicable to Connected Crew and its
                platform.
              </p>
            </li>
          </ol>
          <p>
            <strong className="text-teal">ENGAGEMENT OF CANDIDATE</strong>
          </p>
          <ol start={5} type="1">
            <li>
              <p>
                When introducing a Candidate to the Client, Lloyd Connect will
                provide to the Client:
              </p>
              <ol type="a">
                <li>
                  <p>
                    initially – a copy of the Candidate resume with personal
                    details of the Candidate removed;
                  </p>
                </li>
                <li>
                  <p>
                    at the second interview stage – Candidate references; and
                  </p>
                </li>
                <li>
                  <p>
                    upon a verbal offer being accepted by the Candidate for the
                    Position – the contact details of the Candidate.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                All contact with the Candidate will be via Lloyd Connect until
                verbal offer stage.
              </p>
            </li>
            <li>
              <p>The Client must notify Lloyd Connect immediately upon:</p>
              <ol type="a">
                <li>
                  <p>
                    the Client making an offer of employment to a Candidate; and
                  </p>
                </li>
                <li>
                  <p>
                    a Candidate accepting an offer of employment with the
                    Client;
                  </p>
                </li>
              </ol>
            </li>
          </ol>
          <p>
            with such notification to provide details of the terms of the
            employment, including Remuneration, the proposed start date and any
            change in the description of the Position to that described in the
            Schedule.
          </p>
          <p>
            <strong className="text-teal">REPLACEMENT GUARANTEE</strong>
          </p>
          <ol start={8} type="1">
            <li>
              <p>
                Subject to clause 8 below, if a Candidate employed by the Client
                ceases that employment (<strong>Original Candidate</strong>)
                with the Client within the Guarantee Period, Lloyd Connect will
                use all reasonable endeavours to provide a replacement Candidate
                to at no additional cost to the Client (
                <strong>Replacement Guarantee</strong>).
              </p>
            </li>
            <li>
              <p>
                For the avoidance of doubt, no credit or refund will be provided
                by Lloyd Connect to the Client in the event that a Candidate
                ceases employment with the Client for whatever reason.
              </p>
            </li>
            <li>
              <p>
                The Replacement Guarantee will only apply where all the
                following conditions are satisfied:
              </p>
              <ol type="a">
                <li>
                  <p>
                    the placement fee is paid within the agreed payment terms
                    and there are no outstanding fees, charges and expenses owed
                    by the Client to Lloyd Connect in respect of the Original
                    Candidate or any other services provided by Lloyd Connect to
                    the Client;
                  </p>
                </li>
                <li>
                  <p>
                    Lloyd Connect is notified as soon as practicable in writing
                    that the Original Candidate has ceased employment with the
                    Client and that the Client wishes to invoke the guarantee,
                    and in any event no later than 14 calendar days after the
                    Original Candidate ceased that employment;
                  </p>
                </li>
                <li>
                  <p>
                    the request to replace the Candidate is on Exclusive
                    Recruitment Terms;
                  </p>
                </li>
                <li>
                  <p>the Position is unchanged;</p>
                </li>
                <li>
                  <p>
                    the reason for ceased employment is performance based, and
                    is not due to personal circumstances.
                  </p>
                </li>
                <li>
                  <p>
                    the employment of the Original Candidate did not cease as a
                    result of redundancy, restructuring, economic circumstances,
                    company closure, change of management or substantial change
                    of the Position;
                  </p>
                </li>
                <li>
                  <p>
                    the Original Candidate is not subsequently employed by a
                    related entity of the Client; and
                  </p>
                </li>
                <li>
                  <p>
                    a replacement Candidate has not previously been provided by
                    Lloyd Connect under the Replacement Guarantee in respect of
                    the Services.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                If the remuneration paid to the replacement Candidate is greater
                than the remuneration of the Original Candidate, the fee payable
                will be adjusted accordingly, and Lloyd Connect will provide an
                invoice to the Client for any outstanding amount.
              </p>
            </li>
          </ol>
          <p>
            <strong className="text-teal">TALENT AS A SERVICE (TaaS)</strong>
          </p>
          <ol start={12} type="1">
            <li>
              <p>
                The Services will be provided as a TaaS package if specified in
                the Schedule.
              </p>
            </li>
            <li>
              <p>
                Where the Services are provided as a TaaS package, subject to
                the Client paying the monthly TaaS subscription fee.
              </p>
            </li>
            <li>
              <p>
                12 monthly payments are required and agreed amount of
                recruitment activities are provided.
              </p>
            </li>
          </ol>
          <p>
            <strong className="text-teal">EXCLUSIVE RECRUITMENT TERMS</strong>
          </p>
          <ol start={15} type="1">
            <li>
              <p>
                The Services will be an Exclusive Engagement if specified in the
                Schedule.
              </p>
            </li>
            <li>
              <p>Where the Services are an Exclusive Engagement:</p>
              <ol type="a">
                <li>
                  <p>
                    the Client agrees that it will not enter into an agreement
                    in any form with any other party to perform services the
                    same or similar to the Services; and
                  </p>
                </li>
                <li>
                  <p>
                    the Fee payable will be calculated in accordance with the
                    Exclusive Engagement Fees.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                Should the Client breach the terms of clause 14, the Fee payable
                will be calculated in accordance with the Standard Placement
                Fees.
              </p>
            </li>
          </ol>
          <p>
            <strong className="text-teal">EMPLOYMENT OF CANDIDATE</strong>
          </p>
          <ol start={18} type="1">
            <li>
              <p>
                The parties agree that a Candidate will be considered employed
                by the Client, and a fee payable, if at any time within 12
                months of Lloyd Connect introducing the Candidate to the Client,
                the Candidate is subsequently employed, or otherwise engaged
                (including as an independent contractor or consultant) by:
              </p>
              <ol type="a">
                <li>
                  <p>the Client or a related entity of the Client; or</p>
                </li>
                <li>
                  <p>
                    another entity to which the Client has referred or
                    introduced the Candidate;
                  </p>
                </li>
              </ol>
            </li>
          </ol>
          <p>regardless of whether the Candidate:</p>
          <ol start={3} type="a">
            <li>
              <p>is engaged for the Position or in any other role;</p>
            </li>
            <li>
              <p>
                is engaged either on a full-time, part-time, casual or other
                basis; or
              </p>
            </li>
            <li>
              <p>
                was introduced to the Client by any other means, including an
                introduction by:
              </p>
              <ol type="i">
                <li>
                  <p>another recruitment agency; or</p>
                </li>
                <li>
                  <p>
                    another Candidate previously introduced to the Client by
                    Lloyd Connect within the previous 12 months.
                  </p>
                </li>
              </ol>
            </li>
          </ol>
          <p>
            <strong className="text-teal">FEES</strong>
          </p>
          <ol start={19} type="1">
            <li>
              <p>
                The total fee payable by the Client to Lloyd Connect will be
                calculated as a percentage (as specified in the Schedule) of a
                Candidate’s full time equivalent Remuneration.
              </p>
            </li>
            <li>
              <p>
                The fee will be payable by one of the following methods, as
                specified in the Schedule:
              </p>
              <ol type="a">
                <li>
                  <p>
                    <strong>Commencement Fee &amp; Placement Fee:</strong>
                  </p>
                </li>
              </ol>
            </li>
          </ol>
          <p>
            upon acceptance of terms a $1,500 commencement fee will be charged,
            payable in 14 days with the remaining fee charged at acceptance of
            employment by the successful candidate.
          </p>
          <ol start={2} type="a">
            <li>
              <p>
                <strong>Staggered Payment</strong>:
              </p>
            </li>
          </ol>
          <ol type="i">
            <li>
              <p>
                upon acceptance by the Client of these Terms – 30% of the
                Remuneration as reasonably estimated by the Client;
              </p>
            </li>
            <li>
              <p>
                upon providing Candidate resume/s (with personal details
                removed) to the Client – 30% of the Remuneration as reasonably
                estimated by the Client; and
              </p>
              <ol type="i">
                <li>
                  <p>
                    upon a Candidate commencing employment with the Client (as
                    determined in accordance with clause 16) – any unpaid amount
                    of the total fee payable pursuant to clause 17.
                  </p>
                </li>
              </ol>
              <ol type="a">
                <li>
                  <p>
                    <strong>Temp to Perm Payment:</strong>
                  </p>
                  <ol type="i">
                    <li>
                      <p>
                        upon offer of permanent employment to a temporary
                        Candidate a fee will be due based on a pro-rata basis,
                        calculated as a percentage (as specified in the
                        Schedule) of the successful Candidate’s Remuneration.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  <p>
                    <strong>Temporary Fees:</strong>
                  </p>
                  <ol type="i">
                    <li>
                      <p>
                        Temporary hourly fees are fully inclusive and cover
                        worker’s compensation, payroll tax, superannuation
                        guarantee, Candidate hourly pay rate and casual
                        entitlements in accordance with the appropriate modern
                        award. All temporary Candidates supplied by Lloyd
                        Connect are paid by Lloyd Connect and are employees of
                        Lloyd Connect. All invoice terms for temporary
                        Candidates are strictly 14 days.
                      </p>
                    </li>
                    <li>
                      <p>
                        Temporary Fees are calculated on a case by case basis
                        depending upon role and responsibilities in accordance
                        with the appropriate modern award or calculated based on
                        the positions annual remuneration equivalent.
                      </p>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
          </ol>
          <ol start={21} type="1">
            <li>
              <p>
                If the Services are provided as a TaaS package, the Subscription
                Fee is to be paid by the Client to Lloyd Connect by twelve equal
                monthly instalments in advance on the first day of each month,
                except for the first and last payments which will be calculated
                on a pro rata basis.
              </p>
            </li>
            <li>
              <p>
                The fees payable for the provision of Consulting Services will
                be determined in accordance with the Schedule.
              </p>
            </li>
            <li>
              <p>
                The fee encompasses all reasonable costs in respect of the
                provision of the Services, including online advertising (as
                considered appropriate to the provision of the Services in the
                sole opinion of Lloyd Connect), unless otherwise agreed in
                writing by the parties in advance. Print advertising is not
                included in the fee, and if requested by the Client will be an
                additional cost.
              </p>
            </li>
            <li>
              <p>
                All fees are exclusive of Goods and Services Tax (GST) unless
                expressed otherwise. GST will be added to the fee at the
                relevant rate unless the Services are assessed by Lloyd Connect
                to be GST exempt.
              </p>
            </li>
            <li>
              <p>
                Lloyd Connect must provide an invoice to the Client in respect
                of any fees to be paid. Payment of an invoice is to be made
                within 14 days of the Client receiving the invoice. Where the
                Services are provided as a TaaS package, invoices will be
                provided monthly in advance.
              </p>
            </li>
            <li>
              <p>
                If any amount payable by the Client to Lloyd Connect under these
                Terms has not been paid pursuant to clause 23, Lloyd Connect may
                charge interest on the amount outstanding at the prevailing rate
                of penalty interest prescribed by the Penalty Interest Rates Act
                1983 (Vic) or if this is more than permitted by law then the
                highest rate permitted by law, from the due date for payment
                until the outstanding amount has been paid.
              </p>
            </li>
            <li>
              <p>
                If the Services are provided as a TaaS package, upon the
                termination of these Terms by the Client, any unpaid amount of
                the Subscription Fee becomes immediately payable.
              </p>
            </li>
          </ol>
          <p>
            <strong className="text-teal">CONFIDENTIAL INFORMATION</strong>
          </p>
          <ol start={28} type="1">
            <li>
              <p>
                Each party agrees to keep confidential all Confidential
                Information belonging to the other and not to disclose any
                Confidential Information belonging to the other to any person,
                except as required by law, with the prior written consent of the
                other party, or to a related entity to whom disclosure is
                necessary for the purposes of these Terms and who have first
                undertaken to keep the Confidential Information confidential and
                not to use it except for the purposes of these Terms.
              </p>
            </li>
            <li>
              <p>
                Each party must not use or permit the use of any Confidential
                Information belonging to the other except for the purposes of
                and in accordance with these Terms.
              </p>
            </li>
            <li>
              <p>
                At the completion or earlier termination of these Terms, or at
                any time upon reasonable demand, the Client must either return
                or destroy any and all Confidential Information containing
                Candidate information provided as a result of the Services that
                may be in its possession or control.
              </p>
            </li>
            <li>
              <p>
                The obligations of confidentiality in these Terms survive
                expiration or termination of these Terms and will be enforceable
                at any time at law or in equity and will continue to the benefit
                of and be enforceable by the parties.
              </p>
            </li>
          </ol>
          <p>
            <strong className="text-teal">SPECIAL CONDITIONS</strong>
          </p>
          <ol start={32} type="1">
            <li>
              <p>
                Any Special Conditions set out in the Schedule form part of
                these Terms. To the extent of any inconsistency between these
                Terms and the Special Conditions, the Special Conditions take
                precedence.
              </p>
            </li>
          </ol>
          <p>
            <strong className="text-teal">PRIVACY</strong>
          </p>
          <ol start={33} type="1">
            <li>
              <p>
                The parties agree to comply with all obligations regarding the
                collection, use and disclosure of any personal information
                either party receives in connection with these Terms imposed on
                the parties by the
                <em>Privacy Act 1988</em> (Cth) and any relevant state or
                territory privacy legislation, and each respective parties’
                privacy policy as advised in writing prior to the provision of
                the Services.
              </p>
            </li>
          </ol>
          <p>
            <strong className="text-teal">LIABILITY AND INDEMNITY</strong>
          </p>
          <ol start={34} type="1">
            <li>
              <p>
                The Client acknowledges that while Lloyd Connect will endeavour
                to maintain a high standard of Candidates and to provide proper
                details of their qualifications and experience, Candidate
                details are based on information provided to Lloyd Connect by
                the Candidate, their referees, and other third party
                organisations.
              </p>
            </li>
            <li>
              <p>
                Lloyd Connect is not liable for any errors, omissions,
                inaccuracies or incorrect conclusions. Clients are responsible
                for the final decision to employ the Candidate and must satisfy
                themselves as to the suitability of the Candidate for the
                Position.
              </p>
            </li>
            <li>
              <p>
                Lloyd Connect is not liable for any loss, damage, costs or
                compensation (whether direct or indirect) which may be suffered
                by the Client, or for which the Client may become liable,
                arising from:
              </p>
              <ol type="a">
                <li>
                  <p>
                    the introduction by Lloyd Connect of Candidates to the
                    Client (or delay in any such introduction); or
                  </p>
                </li>
                <li>
                  <p>
                    the failure of a Candidate to accept an offer of employment
                    by the Client.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <p>
                The Client indemnifies Lloyd Connect (and keeps Lloyd Connect
                indemnified) in respect of all claims related to the Candidate’s
                employment with the Client, including but not limited to the
                termination of that employment.
              </p>
            </li>
          </ol>
          <p>
            <strong className="text-teal">GENERAL</strong>
          </p>
          <ol start={38} type="1">
            <li>
              <p>The Client must not solicit Lloyd Connect employees.</p>
            </li>
            <li>
              <p>
                Any variation to these Terms must be mutually agreed by both
                parties in writing.
              </p>
            </li>
            <li>
              <p>
                The Client acknowledges and agrees that Lloyd Connect may assign
                its rights, benefits or obligations under these Terms upon Lloyd
                Connect providing written notice to the Client.
              </p>
            </li>
            <li>
              <p>
                If any provision of these Terms is found to be invalid,
                unenforceable or illegal for any reason, these Terms will remain
                otherwise in full force apart from such provisions which will be
                deemed deleted.
              </p>
            </li>
            <li>
              <p>
                These Terms are to be construed under, and governed by the laws
                of, Victoria and the parties submit to the non-exclusive
                jurisdiction of the courts of that state.
              </p>
            </li>
          </ol>
          <p>
            <strong className="text-teal">TERMINATION OF THESE TERMS</strong>
          </p>
          <ol start={43} type="1">
            <li>
              <p>
                Each party may terminate these Terms by notifying the other
                party either verbally or in writing, with such termination to
                take effect upon the other party being made aware of the
                notification.
              </p>
            </li>
            <li>
              <p>
                Unless otherwise agreed in writing, termination of these Terms
                by either party will also constitute termination of your access
                to Connected Crew and its platform.
              </p>
            </li>
          </ol>
        </>
      </div>
    </>
  );
};

export default TermsOfUse;
